const ENTITY_TYPES = {
  DATASOURCE: "Datasource",
  EXPERIMENT: "Experiment",
  FEATUREEXPERIMENT: "FeatureExperiment",
  METRICSET: "MetricSet",
  COMPUTE: "Compute",
  AUTHENTICATION: "Authentication",
  ANALYSIS: "Analysis"
};
const SUBSCRIPTION_TYPES = {
  Admin: "Admin",
  EntityBase: "EntityBase"
};
export {
  ENTITY_TYPES,
  SUBSCRIPTION_TYPES
};
//# sourceMappingURL=SubscriberModels.js.map
